export default "__VITE_ASSET__Da6e9rEO__"